enum ActionTypes {
    OPEN = "dialog/open",
    CLOSE = "dialog/close"
}

export default ActionTypes;
